
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11571',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11571",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.445",
  "dashboard-client-types": "static-1.229",
  "data-fetching-client": "static-1.9483",
  "foundations-components": "static-1.7530",
  "foundations-components-legacy": "static-1.555",
  "foundations-theming": "static-1.4214",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.77",
  "head-dlb": "static-1.4841",
  "hs-test-utils": "static-1.7810",
  "hub-http-shared-msw-handlers": "static-1.9484",
  "hubspot-dlb": "static-2.1806",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11236",
  "I18n": "static-7.1571",
  "jasmine-runner": "static-1.6277",
  "marketplace-storefront-base": "static-1.11631",
  "quartz": "static-1.6742",
  "react-dlb": "static-1.71",
  "react-rhumb": "static-1.16454",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2666",
  "reporting-testing-lib": "static-1.8473",
  "settings-ui-lib": "static-1.12327",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6739",
  "ui-addon-i18n": "static-1.10943",
  "ui-addon-react-router-dom": "static-1.9351",
  "unified-auth": "static-1.220",
  "unified-auth-core-lib": "static-1.501",
  "usage-tracker": "static-1.7139",
  "usage-tracker-core": "static-1.6989",
  "customer-data-property-utils": "static-1.7882",
  "history": "static-4.47",
  "hub-http": "static-1.6025",
  "integrations-lib": "static-1.15430",
  "marketplace-ui-common": "static-1.18961",
  "property-management-iframe": "static-1.12364",
  "quartz-config": "static-1.520",
  "quartz-core": "static-1.5961",
  "quartz-routing": "static-1.172",
  "quick-fetch": "static-1.3739",
  "react": "static-7.177",
  "rpc-client-utils": "static-1.4439",
  "ts-schema": "static-1.3908",
  "ui-universal-auth": "static-1.8706",
  "UIComponents": "static-3.8183",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.405",
  "hs-promise-rejection-tracking": "static-1.5387",
  "PortalIdParser": "static-2.367",
  "raven": "static-3.5725",
  "raven-hubspot": "static-1.6032",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3231",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3019",
  "quartz-webpack": "static-1.2966",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3799",
  "floating-ui": "static-1.51",
  "foundations-assets": "static-1.4641",
  "foundations-theming-specialty": "static-1.1930",
  "framer-motion": "static-1.67",
  "hs-story-utils": "static-1.9232",
  "react-aria": "static-1.61",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5177",
  "react-virtualized": "static-2.94",
  "StyleGuideUI": "static-3.484",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1211",
  "ui-fonts": "static-1.498",
  "ui-images": "static-2.1093",
  "bend-plugin-foundations-theming": "static-1.2697",
  "foundations-theming-base": "static-1.3199",
  "stylex": "static-1.27",
  "HeadJS": "static-2.710",
  "hs-test-utils-bend-plugin": "static-1.2921",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4131",
  "ai-components-ui-library": "static-1.8358",
  "ai-rendering-library": "static-1.9316",
  "chirp-fetch": "static-1.1687",
  "connections-embed-lib": "static-1.639",
  "copilot-toolkit": "static-1.10542",
  "laboratory-lib": "static-3.6966",
  "marketplace-embed": "static-1.21499",
  "marketplace-ui-details": "static-1.8857",
  "marketplace-ui-reviews": "static-1.18917",
  "marketplace-ui-tracking": "static-1.13132",
  "sanitize-text": "static-1.7945",
  "ui-addon-video-player": "static-1.8501",
  "usage-tracker-multi": "static-1.5553",
  "usage-tracker-session-replay": "static-1.4825",
  "wootric-nps": "static-1.6788",
  "apollo-link-hub-http": "static-2.4454",
  "immer": "static-1.33",
  "immerable": "static-1.3959",
  "highcharts": "static-8.99",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2385",
  "reporting-data": "static-1.66540",
  "cssUtils": "static-1.733",
  "flux-actions": "static-1.309",
  "HubStyle": "static-2.11544",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10014",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10176",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7129",
  "icons": "static-2.622",
  "marketplace-ui-apps-core": "static-1.17494",
  "storybook-react": "static-1.28",
  "trellis-story-utils": "static-1.4326",
  "foundations-components-test-utils": "static-1.5013",
  "quartz-i18n": "static-1.417",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3535",
  "customer-data-objects": "static-1.7454",
  "property-translator": "static-1.5218",
  "frontend-preferences-client": "static-1.7729",
  "hs-promise-utils": "static-1.5398",
  "hubspot-apollo-client": "static-1.4686",
  "integrations-error-boundary-lib": "static-1.12845",
  "integrations-tracking-lib": "static-1.5393",
  "native-integrations-shared-strings": "static-1.7593",
  "reselect": "static-2.16",
  "sanitize": "static-1.4279",
  "superstore": "static-1.4575",
  "ui-shepherd-react": "static-3.9950",
  "ai-settings-ui-library": "static-1.7462",
  "hub-http-janus": "static-1.795",
  "hubspotter-http": "static-1.4482",
  "immutable-less": "static-1.4459",
  "marketplace-ui-client-types": "static-1.16368",
  "nav-meta": "static-1.28921",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10039",
  "ui-addon-upgrades": "static-9.17665",
  "inbound-db-properties-service-client": "static-1.3679",
  "property-management-common": "static-1.4651",
  "ui-addon-iframeable": "static-1.8849",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.483",
  "module-federation": "static-1.18",
  "quartz-auth": "static-1.417",
  "quartz-head": "static-1.407",
  "quartz-test": "static-1.417",
  "quartz-tracking": "static-1.121",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.2947",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20331",
  "ContentUtils": "static-1.67637",
  "sassPrefix": "static-1.152",
  "avatar-components": "static-1.2290",
  "customer-data-filters-ui": "static-1.38925",
  "customer-data-objects-ui-components": "static-1.12812",
  "customer-data-reference-ui-components": "static-1.12950",
  "embedded-academy-lib": "static-1.13547",
  "ExportDialog": "static-6.10191",
  "highlight.js": "static-1.74",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40668",
  "reporting-snowflake": "static-1.55158",
  "reporting-ui-components": "static-2.63811",
  "reporting-visualizations": "static-1.58616",
  "ui-addon-teams": "static-1.21248",
  "magpie-lib": "static-1.5398",
  "magpie-types": "static-1.4858",
  "simple-logging-lib": "static-1.2855",
  "navigation-components": "static-1.17284",
  "ai-studio-lib": "static-1.11014",
  "developer-experience-shared-components": "static-1.10278",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7794",
  "ui-tool-access": "static-1.9949",
  "usage-based-billing-components-lib": "static-1.8012",
  "usage-tracker-anonymous": "static-1.5556",
  "usage-tracker-public": "static-1.6950",
  "amplitude-session-replay-browser": "static-1.55",
  "inbound-db-meta-service-client": "static-1.3421",
  "persist-promise": "static-1.3513",
  "reference-resolvers": "static-1.7965",
  "ui-extensibility-client-types": "static-1.3749",
  "hubspot-apollo-cache": "static-1.145",
  "universal-page-editor-lib": "static-1.2804",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2201",
  "merchandise-lib": "static-1.259",
  "atom": "static-1.4874",
  "purchase-motions-components": "static-1.5489",
  "salesImages": "static-1.521",
  "batch-promise": "static-1.1356",
  "crm-component-utils": "static-1.38494",
  "crm-properties-common-lib": "static-1.5677",
  "framework-data-schema-resolvers": "static-1.6678",
  "reference-resolvers-lite": "static-1.7899",
  "navigation-messaging": "static-1.6611",
  "hubspotter-http-shared-msw-handlers": "static-1.9482",
  "cms-field-types": "static-1.4611",
  "content-icons-ui": "static-1.2155",
  "conversations-skeleton-state": "static-1.7052",
  "crm-message-bus": "static-1.42381",
  "customer-data-filters-ui-msw-helpers": "static-1.21360",
  "customer-data-ui-utilities": "static-1.9628",
  "FormUrlGenerator": "static-2.4534",
  "framework-builder-read-service-client": "static-1.3837",
  "framework-data-schema-quick-fetch": "static-1.6583",
  "multi-account-reference-resolvers": "static-1.778",
  "onboarding-tours": "static-1.16266",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13064",
  "academy-common-lib": "static-1.13007",
  "content-assistance-lib": "static-1.7455",
  "dashboard-lib": "static-1.80643",
  "file-manager-components": "static-1.22899",
  "getting-started-shared-tasks": "static-1.17897",
  "hubspot-prosemirror": "static-1.17618",
  "hubspot-prosemirror-plugins": "static-1.17610",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19475",
  "share-with-third-party-component-lib": "static-1.8496",
  "ui-addon-draggable": "static-3.4570",
  "ui-asset-management-lib": "static-1.10713",
  "ui-business-units-lib": "static-1.8831",
  "user-context": "static-1.4904",
  "growth-payments-core": "static-1.24742",
  "reporting-plugins": "static-1.9989",
  "reporting-reports": "static-1.66218",
  "idb-keyval": "static-1.39",
  "reactive-lib": "static-1.530",
  "codemirror": "static-5.90",
  "feedback-loader": "static-1.28861",
  "react-codemirror": "static-1.10431",
  "apps-service-types": "static-1.3682",
  "oauth-service-types": "static-1.4047",
  "onboarding-scopes": "static-1.6268",
  "onboarding-tours-client": "static-1.4480",
  "platform-infra-nav-components": "static-1.7496",
  "subscription-experience-data-types": "static-1.14592",
  "crm-record-cards-service-types": "static-1.3456",
  "location-customization-utils-lib": "static-1.8576",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4318",
  "nav-client-types": "static-1.2162",
  "purchase-motions-api": "static-1.5492",
  "signup-constants": "static-1.18413",
  "signup-ui-url-generator": "static-2.7858",
  "trials-service-types": "static-1.3719",
  "card-properties-lib": "static-1.43536",
  "crm-actions": "static-1.6106",
  "crm-cards-data": "static-1.1217",
  "crm-cards-sdk": "static-1.42937",
  "customer-data-properties": "static-1.50814",
  "customer-data-properties-shared-msw-handlers": "static-1.8811",
  "customer-data-tracking": "static-1.6687",
  "conditional-properties-service-client": "static-1.3627",
  "crm-pipelines-api-client-types": "static-1.3968",
  "multi-currency-client-types": "static-1.3521",
  "external-options-client-types": "static-1.3988",
  "react-dnd-compat": "static-1.4425",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5162",
  "growth-onboarding-confetti": "static-1.2876",
  "growth-onboarding-next-action-utils": "static-1.1303",
  "onboarding-tours-utils": "static-1.332",
  "ui-shepherd-tracker": "static-1.7331",
  "academy-service-client": "static-1.3485",
  "final-form": "static-1.65",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.27956",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8189",
  "video-components-external": "static-1.10577",
  "video-data-lib": "static-1.34235",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8373",
  "payment-link-components": "static-1.22954",
  "ui-addon-emoji-picker": "static-1.9693",
  "EmailSignatureEditor": "static-1.23918",
  "viral-links-lib": "static-1.6840",
  "data-token-picker": "static-1.16048",
  "FileManagerLib": "static-1.38539",
  "react-flip-move": "static-1.65",
  "timezone-utils": "static-2.5049",
  "getting-started-shared-tasks-store": "static-1.17015",
  "campaign-roi-lib": "static-1.8288",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.195",
  "eligibility-engine-service-types": "static-1.3000",
  "crm_data": "static-4.91232",
  "crm-links": "static-1.6070",
  "customer-data-sidebar": "static-2.45431",
  "enrichment-properties-lib": "static-1.15039",
  "crm-fe-perf": "static-1.22710",
  "calling-global-api": "static-1.63684",
  "calling-internal-common": "static-1.31099",
  "calling-lifecycle-internal": "static-1.65066",
  "calling-lifecycle-messages": "static-1.57360",
  "commerce-products-lib": "static-1.8873",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.483",
  "inbounddb-objects-service-types": "static-1.4053",
  "meetings-icalendar-utils-lib": "static-1.438",
  "object-builder-ui-client": "static-1.47995",
  "pipeline-validation-client-types": "static-1.3790",
  "property-value-citations": "static-1.1428",
  "pulse": "static-1.316",
  "smart-property-lib": "static-1.5921",
  "tiered-pricing": "static-1.835",
  "ui-addon-form-validation": "static-1.10799",
  "growth-onboarding-next-action-components": "static-1.1331",
  "growth-onboarding-feedback-components": "static-1.6388",
  "content-media-composition-data-lib": "static-1.11467",
  "content-media-compositions": "static-2.15474",
  "media-bridge-lib": "static-1.18570",
  "commerce-tours-lib": "static-1.5725",
  "growth-onboarding-reliability": "static-1.4891",
  "sales-checkout-service-client": "static-1.3473",
  "draft-convert": "static-2.67",
  "draft-extend": "static-3.70",
  "draft-js": "static-5.72",
  "draft-plugins": "static-2.21312",
  "sales-email-signature-service-client": "static-1.3649",
  "audio-components": "static-1.5619",
  "FileManagerCore": "static-1.38398",
  "FileManagerImages": "static-1.36050",
  "video-components": "static-1.12580",
  "crm_universal": "static-1.21666",
  "customer-data-email": "static-1.17675",
  "calling-error-reporting": "static-1.31105",
  "card-payment-highlight-lib": "static-1.36518",
  "card-subscription-highlight-lib": "static-1.38873",
  "commerce-billing-lib": "static-1.18516",
  "commerce-contract-lib": "static-1.11212",
  "customer-data-content": "static-1.26876",
  "invoices-highlight-card-lib": "static-1.54042",
  "orders-highlight-card-lib": "static-1.20880",
  "products-highlight-card-lib": "static-1.17157",
  "project-storage": "static-1.4538",
  "quotes-highlight-card-lib": "static-1.71222",
  "breeze-intelligence-kit": "static-1.5327",
  "crm-source-interpretation-lib": "static-1.5134",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9567",
  "policy-lib": "static-1.6588",
  "shared-worker-versioning": "static-1.10843",
  "calling-usage-tracker": "static-1.6345",
  "voice-sms-access-library": "static-1.261",
  "commerce-permissions": "static-1.563",
  "products-iframe-lib": "static-1.7330",
  "products-ui-components-shared-msw-handlers": "static-1.9866",
  "directed-graph": "static-1.741",
  "event-emitter": "static-1.752",
  "react-tinymce": "static-1.54635",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9630",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53761",
  "tinymce-plugins": "static-1.56875",
  "tinymce-themes": "static-1.55731",
  "hls.js": "static-1.34",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4337",
  "video-embed": "static-1.35069",
  "social-insights-client-types": "static-1.21349",
  "sequences-lib": "static-1.7695",
  "ui-gdpr-components": "static-1.10152",
  "commerce-shared-components-lib": "static-1.17926",
  "commerce-subscription-lib": "static-1.36450",
  "commerce-tools-ui-lib": "static-1.9803",
  "utility-belt": "static-1.2345",
  "payments-enrollment-embed-lib": "static-1.22038",
  "products-ui-components": "static-1.39392",
  "quotes-client-types": "static-1.37310",
  "quotes-ui-lib": "static-1.79941",
  "SalesContentIndexUI": "static-3.8907",
  "accounting-integrations-ui-components": "static-1.6729",
  "invoices-ui-lib": "static-1.54058",
  "commerce-products-api": "static-1.1963",
  "SafeStorage": "static-1.4209",
  "invoices-iframe-lib": "static-1.56116",
  "quotes-modal-lib": "static-1.101898",
  "calling-orchestration-schema": "static-1.35038",
  "sales-views-client-types": "static-1.4092",
  "hub-http-contrib": "static-1.2848",
  "interframe": "static-3.4595",
  "tinymce-data": "static-1.39846",
  "ui-addon-sales-email": "static-1.5018",
  "layout-dnd-components": "static-1.12038",
  "layout-dnd-utils": "static-1.11013",
  "ui-brand-identity-lib": "static-1.13902",
  "NamespacedHubStyle": "static-2.8900",
  "outpost": "static-1.4009",
  "sequences-client-types-lib": "static-1.7552",
  "customer-data-associations": "static-1.7143",
  "framework-data-table": "static-2.11423",
  "customer-data-rte": "static-1.32454",
  "cv-backend-services": "static-1.1504",
  "growth-onboarding-empty-states": "static-1.5370",
  "InboxConnectUtils": "static-4.14236",
  "payments-post-enroll-local-storage-lib": "static-1.4916",
  "qrcode-generator": "static-1.64",
  "stripe-embedded-components": "static-1.7138",
  "commerce-tax-lib": "static-1.323",
  "property-description-translator": "static-1.3664",
  "FireAlarmUi": "static-1.4333",
  "sales-templates-service-types-lib": "static-1.3995",
  "commerce-analytics-service-client": "static-1.3461",
  "totals-ui-components": "static-1.23012",
  "ContentData": "static-1.67712",
  "layout-data-lib": "static-1.9338",
  "deal-intel-decorators": "static-1.1273",
  "tanstack-virtual": "static-1.25",
  "draft-content-plugins": "static-1.27723",
  "stripe-connect-js": "static-1.64",
  "commerce-totals-service-types": "static-1.3641",
  "advanced-menus-core": "static-1.14821",
  "advanced-menus-lib": "static-1.11795",
  "ui-memberships-settings-lib": "static-1.33438",
  "deal-intel-utils": "static-1.1277",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14820",
  "simple-menus-lib": "static-1.16337"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11571",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.445",
  "dashboard-client-types": "/dashboard-client-types/static-1.229",
  "data-fetching-client": "/data-fetching-client/static-1.9483",
  "foundations-components": "/foundations-components/static-1.7530",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.555",
  "foundations-theming": "/foundations-theming/static-1.4214",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.77",
  "head-dlb": "/head-dlb/static-1.4841",
  "hs-test-utils": "/hs-test-utils/static-1.7810",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9484",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11236",
  "I18n": "/I18n/static-7.1571",
  "jasmine-runner": "/jasmine-runner/static-1.6277",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11631",
  "quartz": "/quartz/static-1.6742",
  "react-dlb": "/react-dlb/static-1.71",
  "react-rhumb": "/react-rhumb/static-1.16454",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2666",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8473",
  "settings-ui-lib": "/settings-ui-lib/static-1.12327",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6739",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10943",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9351",
  "unified-auth": "/unified-auth/static-1.220",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.501",
  "usage-tracker": "/usage-tracker/static-1.7139",
  "usage-tracker-core": "/usage-tracker-core/static-1.6989",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7882",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6025",
  "integrations-lib": "/integrations-lib/static-1.15430",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.18961",
  "property-management-iframe": "/property-management-iframe/static-1.12364",
  "quartz-config": "/quartz-config/static-1.520",
  "quartz-core": "/quartz-core/static-1.5961",
  "quartz-routing": "/quartz-routing/static-1.172",
  "quick-fetch": "/quick-fetch/static-1.3739",
  "react": "/react/static-7.177",
  "rpc-client-utils": "/rpc-client-utils/static-1.4439",
  "ts-schema": "/ts-schema/static-1.3908",
  "ui-universal-auth": "/ui-universal-auth/static-1.8706",
  "UIComponents": "/UIComponents/static-3.8183",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.405",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
  "PortalIdParser": "/PortalIdParser/static-2.367",
  "raven": "/raven/static-3.5725",
  "raven-hubspot": "/raven-hubspot/static-1.6032",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3231",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3019",
  "quartz-webpack": "/quartz-webpack/static-1.2966",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3799",
  "floating-ui": "/floating-ui/static-1.51",
  "foundations-assets": "/foundations-assets/static-1.4641",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1930",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-story-utils": "/hs-story-utils/static-1.9232",
  "react-aria": "/react-aria/static-1.61",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5177",
  "react-virtualized": "/react-virtualized/static-2.94",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1211",
  "ui-fonts": "/ui-fonts/static-1.498",
  "ui-images": "/ui-images/static-2.1093",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2697",
  "foundations-theming-base": "/foundations-theming-base/static-1.3199",
  "stylex": "/stylex/static-1.27",
  "HeadJS": "/HeadJS/static-2.710",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2921",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4131",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8358",
  "ai-rendering-library": "/ai-rendering-library/static-1.9316",
  "chirp-fetch": "/chirp-fetch/static-1.1687",
  "connections-embed-lib": "/connections-embed-lib/static-1.639",
  "copilot-toolkit": "/copilot-toolkit/static-1.10542",
  "laboratory-lib": "/laboratory-lib/static-3.6966",
  "marketplace-embed": "/marketplace-embed/static-1.21499",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8857",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.18917",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13132",
  "sanitize-text": "/sanitize-text/static-1.7945",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8501",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5553",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4825",
  "wootric-nps": "/wootric-nps/static-1.6788",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4454",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3959",
  "highcharts": "/highcharts/static-8.99",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2385",
  "reporting-data": "/reporting-data/static-1.66540",
  "cssUtils": "/cssUtils/static-1.733",
  "flux-actions": "/flux-actions/static-1.309",
  "HubStyle": "/HubStyle/static-2.11544",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10014",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10176",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7129",
  "icons": "/icons/static-2.622",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17494",
  "storybook-react": "/storybook-react/static-1.28",
  "trellis-story-utils": "/trellis-story-utils/static-1.4326",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5013",
  "quartz-i18n": "/quartz-i18n/static-1.417",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3535",
  "customer-data-objects": "/customer-data-objects/static-1.7454",
  "property-translator": "/property-translator/static-1.5218",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7729",
  "hs-promise-utils": "/hs-promise-utils/static-1.5398",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4686",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12845",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5393",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7593",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4279",
  "superstore": "/superstore/static-1.4575",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9950",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7462",
  "hub-http-janus": "/hub-http-janus/static-1.795",
  "hubspotter-http": "/hubspotter-http/static-1.4482",
  "immutable-less": "/immutable-less/static-1.4459",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16368",
  "nav-meta": "/nav-meta/static-1.28921",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10039",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17665",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3679",
  "property-management-common": "/property-management-common/static-1.4651",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8849",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.483",
  "module-federation": "/module-federation/static-1.18",
  "quartz-auth": "/quartz-auth/static-1.417",
  "quartz-head": "/quartz-head/static-1.407",
  "quartz-test": "/quartz-test/static-1.417",
  "quartz-tracking": "/quartz-tracking/static-1.121",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.2947",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20331",
  "ContentUtils": "/ContentUtils/static-1.67637",
  "sassPrefix": "/sassPrefix/static-1.152",
  "avatar-components": "/avatar-components/static-1.2290",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38925",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12812",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12950",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13547",
  "ExportDialog": "/ExportDialog/static-6.10191",
  "highlight.js": "/highlight.js/static-1.74",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40668",
  "reporting-snowflake": "/reporting-snowflake/static-1.55158",
  "reporting-ui-components": "/reporting-ui-components/static-2.63811",
  "reporting-visualizations": "/reporting-visualizations/static-1.58616",
  "ui-addon-teams": "/ui-addon-teams/static-1.21248",
  "magpie-lib": "/magpie-lib/static-1.5398",
  "magpie-types": "/magpie-types/static-1.4858",
  "simple-logging-lib": "/simple-logging-lib/static-1.2855",
  "navigation-components": "/navigation-components/static-1.17284",
  "ai-studio-lib": "/ai-studio-lib/static-1.11014",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10278",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7794",
  "ui-tool-access": "/ui-tool-access/static-1.9949",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8012",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5556",
  "usage-tracker-public": "/usage-tracker-public/static-1.6950",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3421",
  "persist-promise": "/persist-promise/static-1.3513",
  "reference-resolvers": "/reference-resolvers/static-1.7965",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3749",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.145",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2804",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2201",
  "merchandise-lib": "/merchandise-lib/static-1.259",
  "atom": "/atom/static-1.4874",
  "purchase-motions-components": "/purchase-motions-components/static-1.5489",
  "salesImages": "/salesImages/static-1.521",
  "batch-promise": "/batch-promise/static-1.1356",
  "crm-component-utils": "/crm-component-utils/static-1.38494",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5677",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6678",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7899",
  "navigation-messaging": "/navigation-messaging/static-1.6611",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9482",
  "cms-field-types": "/cms-field-types/static-1.4611",
  "content-icons-ui": "/content-icons-ui/static-1.2155",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7052",
  "crm-message-bus": "/crm-message-bus/static-1.42381",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21360",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9628",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4534",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3837",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6583",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.778",
  "onboarding-tours": "/onboarding-tours/static-1.16266",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13064",
  "academy-common-lib": "/academy-common-lib/static-1.13007",
  "content-assistance-lib": "/content-assistance-lib/static-1.7455",
  "dashboard-lib": "/dashboard-lib/static-1.80643",
  "file-manager-components": "/file-manager-components/static-1.22899",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17897",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17618",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17610",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19475",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8496",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4570",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10713",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8831",
  "user-context": "/user-context/static-1.4904",
  "growth-payments-core": "/growth-payments-core/static-1.24742",
  "reporting-plugins": "/reporting-plugins/static-1.9989",
  "reporting-reports": "/reporting-reports/static-1.66218",
  "idb-keyval": "/idb-keyval/static-1.39",
  "reactive-lib": "/reactive-lib/static-1.530",
  "codemirror": "/codemirror/static-5.90",
  "feedback-loader": "/feedback-loader/static-1.28861",
  "react-codemirror": "/react-codemirror/static-1.10431",
  "apps-service-types": "/apps-service-types/static-1.3682",
  "oauth-service-types": "/oauth-service-types/static-1.4047",
  "onboarding-scopes": "/onboarding-scopes/static-1.6268",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4480",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7496",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14592",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3456",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8576",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4318",
  "nav-client-types": "/nav-client-types/static-1.2162",
  "purchase-motions-api": "/purchase-motions-api/static-1.5492",
  "signup-constants": "/signup-constants/static-1.18413",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7858",
  "trials-service-types": "/trials-service-types/static-1.3719",
  "card-properties-lib": "/card-properties-lib/static-1.43536",
  "crm-actions": "/crm-actions/static-1.6106",
  "crm-cards-data": "/crm-cards-data/static-1.1217",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.42937",
  "customer-data-properties": "/customer-data-properties/static-1.50814",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8811",
  "customer-data-tracking": "/customer-data-tracking/static-1.6687",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3627",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3968",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3521",
  "external-options-client-types": "/external-options-client-types/static-1.3988",
  "react-dnd-compat": "/react-dnd-compat/static-1.4425",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5162",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2876",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1303",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.332",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7331",
  "academy-service-client": "/academy-service-client/static-1.3485",
  "final-form": "/final-form/static-1.65",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27956",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8189",
  "video-components-external": "/video-components-external/static-1.10577",
  "video-data-lib": "/video-data-lib/static-1.34235",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8373",
  "payment-link-components": "/payment-link-components/static-1.22954",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9693",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23918",
  "viral-links-lib": "/viral-links-lib/static-1.6840",
  "data-token-picker": "/data-token-picker/static-1.16048",
  "FileManagerLib": "/FileManagerLib/static-1.38539",
  "react-flip-move": "/react-flip-move/static-1.65",
  "timezone-utils": "/timezone-utils/static-2.5049",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17015",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8288",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.195",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3000",
  "crm_data": "/crm_data/static-4.91232",
  "crm-links": "/crm-links/static-1.6070",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45431",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15039",
  "crm-fe-perf": "/crm-fe-perf/static-1.22710",
  "calling-global-api": "/calling-global-api/static-1.63684",
  "calling-internal-common": "/calling-internal-common/static-1.31099",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65066",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57360",
  "commerce-products-lib": "/commerce-products-lib/static-1.8873",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.483",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4053",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.438",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47995",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3790",
  "property-value-citations": "/property-value-citations/static-1.1428",
  "pulse": "/pulse/static-1.316",
  "smart-property-lib": "/smart-property-lib/static-1.5921",
  "tiered-pricing": "/tiered-pricing/static-1.835",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10799",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1331",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6388",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11467",
  "content-media-compositions": "/content-media-compositions/static-2.15474",
  "media-bridge-lib": "/media-bridge-lib/static-1.18570",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5725",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4891",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3473",
  "draft-convert": "/draft-convert/static-2.67",
  "draft-extend": "/draft-extend/static-3.70",
  "draft-js": "/draft-js/static-5.72",
  "draft-plugins": "/draft-plugins/static-2.21312",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3649",
  "audio-components": "/audio-components/static-1.5619",
  "FileManagerCore": "/FileManagerCore/static-1.38398",
  "FileManagerImages": "/FileManagerImages/static-1.36050",
  "video-components": "/video-components/static-1.12580",
  "crm_universal": "/crm_universal/static-1.21666",
  "customer-data-email": "/customer-data-email/static-1.17675",
  "calling-error-reporting": "/calling-error-reporting/static-1.31105",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36518",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38873",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18516",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11212",
  "customer-data-content": "/customer-data-content/static-1.26876",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54042",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20880",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17157",
  "project-storage": "/project-storage/static-1.4538",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71222",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5327",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5134",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9567",
  "policy-lib": "/policy-lib/static-1.6588",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10843",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6345",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.261",
  "commerce-permissions": "/commerce-permissions/static-1.563",
  "products-iframe-lib": "/products-iframe-lib/static-1.7330",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9866",
  "directed-graph": "/directed-graph/static-1.741",
  "event-emitter": "/event-emitter/static-1.752",
  "react-tinymce": "/react-tinymce/static-1.54635",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9630",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53761",
  "tinymce-plugins": "/tinymce-plugins/static-1.56875",
  "tinymce-themes": "/tinymce-themes/static-1.55731",
  "hls.js": "/hls.js/static-1.34",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4337",
  "video-embed": "/video-embed/static-1.35069",
  "social-insights-client-types": "/social-insights-client-types/static-1.21349",
  "sequences-lib": "/sequences-lib/static-1.7695",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10152",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17926",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36450",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9803",
  "utility-belt": "/utility-belt/static-1.2345",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22038",
  "products-ui-components": "/products-ui-components/static-1.39392",
  "quotes-client-types": "/quotes-client-types/static-1.37310",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.79941",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8907",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6729",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54058",
  "commerce-products-api": "/commerce-products-api/static-1.1963",
  "SafeStorage": "/SafeStorage/static-1.4209",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56116",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.101898",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35038",
  "sales-views-client-types": "/sales-views-client-types/static-1.4092",
  "hub-http-contrib": "/hub-http-contrib/static-1.2848",
  "interframe": "/interframe/static-3.4595",
  "tinymce-data": "/tinymce-data/static-1.39846",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5018",
  "layout-dnd-components": "/layout-dnd-components/static-1.12038",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11013",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13902",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8900",
  "outpost": "/outpost/static-1.4009",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7552",
  "customer-data-associations": "/customer-data-associations/static-1.7143",
  "framework-data-table": "/framework-data-table/static-2.11423",
  "customer-data-rte": "/customer-data-rte/static-1.32454",
  "cv-backend-services": "/cv-backend-services/static-1.1504",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5370",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14236",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4916",
  "qrcode-generator": "/qrcode-generator/static-1.64",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7138",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.323",
  "property-description-translator": "/property-description-translator/static-1.3664",
  "FireAlarmUi": "/FireAlarmUi/static-1.4333",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3995",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3461",
  "totals-ui-components": "/totals-ui-components/static-1.23012",
  "ContentData": "/ContentData/static-1.67712",
  "layout-data-lib": "/layout-data-lib/static-1.9338",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1273",
  "tanstack-virtual": "/tanstack-virtual/static-1.25",
  "draft-content-plugins": "/draft-content-plugins/static-1.27723",
  "stripe-connect-js": "/stripe-connect-js/static-1.64",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3641",
  "advanced-menus-core": "/advanced-menus-core/static-1.14821",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11795",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33438",
  "deal-intel-utils": "/deal-intel-utils/static-1.1277",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14820",
  "simple-menus-lib": "/simple-menus-lib/static-1.16337"
}
};
